import { useMemo } from "react";

// Platforms
import { Iterable } from "platforms/iterable/iterable";

// Utils
import { formatIterableEmbeddedMessageForPreviewCard } from "platforms/iterable/utils/utils";

export const useDashboardMessagesPreviewCard = ({ message }) => {
    /**
     * useMemo
     */

    const isClaimLetterAction = useMemo(() => {
        const buttons = message?.elements?.buttons || [];
        return buttons.some((button) =>
            button?.action?.type?.startsWith("action://free-letter/")
        );
    }, [message]);

    const item = useMemo(() => {
        if (!message) return null;
        return formatIterableEmbeddedMessageForPreviewCard({ message });
    }, [message]);

    /**
     * End Hooks
     */

    function handleTrackIterableClickEvent() {
        Iterable.trackEmbeddedMessageClickEvent({ message });
    }

    return {
        handleTrackIterableClickEvent,
        isClaimLetterAction,
        item,
    };
};
